<script lang="ts" setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <rect width="24" height="24" fill="#374650" rx="3" />
    <path
      fill="#E6FFF5"
      d="M17 10c0-2.763-2.238-5-5-5s-5 2.237-5 5c0 .488.169 1.156.519 1.981.34.81.819 1.688 1.362 2.566 1.066 1.728 2.325 3.381 3.122 4.375.794-.994 2.056-2.647 3.122-4.375.54-.878 1.022-1.76 1.363-2.566.343-.825.512-1.493.512-1.981Zm1 0c0 2.731-3.656 7.594-5.26 9.6a.944.944 0 0 1-1.48 0C9.655 17.594 6 12.731 6 10c0-3.313 2.688-6 6-6 3.313 0 6 2.688 6 6Zm-7.5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm1.5 2.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"
    />
  </svg>
</template>
